import { Flex, Modal, ModalProps, Typography } from "antd";

const { Text } = Typography;

export default function TwoDayModal(props: ModalProps) {
  return (
    <Modal
      title="Submission Confirmed!"
      okText="Confirm" {...props}
      cancelButtonProps={{ style: { display: "none" } }}
      closable={false}
    >
      <Flex gap={8} vertical>
        <Text>Your QR code will be sent 2 days before your arrival date!</Text>
        <Text>
          If you need to edit the date, please click on the same link in the
          email!
        </Text>
      </Flex>
    </Modal>
  )
}